import React from "react";
import { ReactSortable } from "react-sortablejs";
import Input from "../FormComponents/Input";
import Button from "../FormComponents/Button";
import MaterialIcon from "../BuilderComponents/MaterialIcon";
import { generateObjectId } from "../../utils/objectIdUtils";

const EditPositionedTab = ({ editElementData, setEditElementData }) => {
  const handleTabNameChange = (e, tabId) => {
    const updatedTabs = editElementData.map((tab) => (tab.id === tabId ? { ...tab, name: e.target.value } : tab));
    setEditElementData(updatedTabs);
  };

  const handleChangeTabOrder = (newOrder) => {
    setEditElementData(newOrder);
  };

  const handleAddTab = () => {
    const newTab = {
      children: [
        {
          id: generateObjectId(),
          type: "full",
          style: { width: "100%", height: "100%", position: "absolute" },
          children: [
            {
              id: generateObjectId(),
              type: "section",
              style: { width: "100%", height: "120px", position: "relative" },
              classes: [],
              children: []
            }
          ]
        }
      ],
      id: generateObjectId(),
      name: "Tab"
    };
    setEditElementData([...editElementData, newTab]);
  };

  const handleDeleteTab = (tabId) => {
    const updatedTabs = editElementData.filter((tab) => tab.id !== tabId);
    setEditElementData(updatedTabs);
  };

  return (
    <div className="p_2">
      <Button onClick={handleAddTab} size="sm" className="mb_2" variant="secondary">
        Add Tab
      </Button>
      <ReactSortable list={editElementData} setList={handleChangeTabOrder} animation="200" easing="ease-out">
        {editElementData &&
          editElementData.map((tab) => (
            <div key={tab.id} className="d_flex gap_2 align_center mb_2">
              <Input
                type="text"
                value={tab.name}
                onChange={(e) => handleTabNameChange(e, tab.id)}
                placeholder="Edit tab name"
              />
              <MaterialIcon
                name="delete"
                className="font_size_medium"
                style={{ color: "red", cursor: "pointer" }}
                onClick={() => handleDeleteTab(tab.id)}
              />
            </div>
          ))}
      </ReactSortable>
    </div>
  );
};

export default EditPositionedTab;
